import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Volume2, FileText } from 'lucide-react';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';

const HearingKnowledge = ({ t }) => {
  const navigate = useNavigate();

  const [audiogramImage, setAudiogramImage] = useState(null);
  const [audiogramReading, setAudiogramReading] = useState(false);
  const [audiogramStep, setAudiogramStep] = useState(null);

  const readAudiogramFromCamera = async () => {
  try {
    const image = await Camera.getPhoto({
      quality: 85,
      allowEditing: false,
      resultType: CameraResultType.DataUrl,
      source: CameraSource.Prompt,
    });

    if (!image?.dataUrl) return;

    console.log('[Audiogram Reader] Image received');

    setAudiogramImage(image.dataUrl);
    setAudiogramReading(true);
    setAudiogramStep('received');

  } catch (error) {
    console.warn('[Audiogram Reader] Camera cancelled or failed:', error);
  }
};

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white pt-28 pb-32">
      <div className="max-w-3xl mx-auto px-6">
        <h1 className="text-4xl font-bold text-slate-900">
          {t?.hearingKnowledgeTitle || 'Connaître votre audition'}
        </h1>

        <p className="mt-4 text-slate-800 text-lg leading-relaxed max-w-2xl">
          {t?.hearingKnowledgeIntro ||
            'Votre audition est unique. Hearen peut commencer à la comprendre de deux façons.'}
        </p>

        <div className="mt-10 rounded-3xl bg-white/80 backdrop-blur-sm border border-white shadow-lg p-6">
  <div className="flex gap-4 mb-6">
    <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
      <Volume2 size={24} className="text-blue-700" />
    </div>

    <div>
      <h2 className="text-2xl font-bold text-slate-900">
        {t?.exploreMyHearing || 'Explorer mon écoute'}
      </h2>
      <p className="mt-2 text-slate-700 leading-relaxed">
        {t?.exploreMyHearingDesc ||
          'Choisissez comment Hearen peut commencer à comprendre votre audition.'}
      </p>
    </div>
  </div>

  <div className="space-y-3">
    <button
      onClick={() => navigate('/audiometric-test')}
      className="w-full text-left rounded-2xl bg-blue-50/70 border border-blue-100 px-4 py-4 active:scale-[0.98] transition-all"
    >
      <div className="font-semibold text-slate-900">
        {t?.startHearingTest || 'Réaliser un test auditif Hearen'}
      </div>
      <div className="text-sm text-slate-600 mt-1">
        {t?.startHearingTestDesc ||
          'Explorer votre écoute directement dans l’application.'}
      </div>
    </button>

    <button
      onClick={() => navigate('/clinical-audiogram')}
      className="w-full text-left rounded-2xl bg-emerald-50/70 border border-emerald-100 px-4 py-4 active:scale-[0.98] transition-all"
    >
      <div className="font-semibold text-slate-900">
        {t?.readClinicalAudiogram || 'Lire un audiogramme clinique'}
      </div>
      <div className="text-sm text-slate-600 mt-1">
        {t?.readClinicalAudiogramDesc ||
          'Utiliser un audiogramme réalisé par un professionnel.'}
      </div>
    </button>

    <button
      onClick={() => navigate('/history')}
      className="w-full text-left rounded-2xl bg-slate-50 border border-slate-100 px-4 py-4 active:scale-[0.98] transition-all"
    >
      <div className="font-semibold text-slate-900">
        {t?.viewHistory || 'Consulter mon historique'}
      </div>
      <div className="text-sm text-slate-600 mt-1">
        {t?.viewHistoryDesc ||
          'Retrouver vos anciens résultats et suivre votre trajectoire.'}
      </div>
    </button>
  </div>
</div>

        <p className="mt-8 text-sm text-slate-600 leading-relaxed">
          {t?.hearingKnowledgeFooter ||
            'Les deux approches permettent ensuite à Hearen de personnaliser votre expérience d’écoute.'}
        </p>
      </div>
    </div>
  );
};

export default HearingKnowledge;